import Autocomplete from "@mui/material/Autocomplete";
import CircularProgress from "@mui/material/CircularProgress";
import TextField from "@mui/material/TextField";

const defaultGetOptionLabel = (option) => {
	if (option == null) return "";
	if (typeof option === "string") return option;
	return option?.label || option?.name || option?.title || option?.value || "";
};

const defaultGetOptionValue = (option) => {
	if (option == null) return "";
	if (typeof option === "string") return option;
	return option?.value || option?._id || option?.id || "";
};

function FilterAutocomplete({
	name,
	label,
	value = "",
	options = [],
	onChange,
	getOptionLabel = defaultGetOptionLabel,
	getOptionValue = defaultGetOptionValue,
	placeholder = "Select an option",
	loading = false,
	disabled = false,
	size = "small",
	fullWidth = true
}) {
	const resolvedOptions = Array.isArray(options) ? options : [];
	const selectedOption =
		resolvedOptions.find((option) => getOptionValue(option) === value) || null;

	return (
		<Autocomplete
			fullWidth={fullWidth}
			size={size}
			options={resolvedOptions}
			value={selectedOption}
			onChange={(event, newValue) => {
				if (onChange) {
					onChange(name, newValue ? getOptionValue(newValue) : "");
				}
			}}
			loading={loading}
			disabled={disabled}
			autoHighlight
			includeInputInList
			clearOnEscape
			getOptionLabel={(option) => getOptionLabel(option) || ""}
			isOptionEqualToValue={(option, val) => getOptionValue(option) === getOptionValue(val)}
			renderInput={(params) => (
				<TextField
					{...params}
					label={label}
					placeholder={placeholder}
					size={size}
					InputProps={{
						...params.InputProps,
						endAdornment: (
							<>
								{loading ? <CircularProgress color="inherit" size={16} /> : null}
								{params.InputProps.endAdornment}
							</>
						)
					}}
				/>
			)}
		/>
	);
}

export default FilterAutocomplete;
